import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  return (
    <>
      <Modal
        title={`Nuevo Color para bonos`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/bono-colores'
      >
        <TextField
          label="Color"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          value={dataChanging.description || ''}
          onChange={(e) => handleChange('description', e.target.value)}
          required
        />
      </Modal>
    </>
  );
});
